<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>模版管理</el-breadcrumb-item>
      <el-breadcrumb-item>储值卡模版</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="0">
        <el-col :span="9">
          <el-input placeholder="请输入查询内容" v-model="queryInfo.query" class="input-with-select" clearable
            style="width:300px;" @clear="getmobanChuzhiList" @change="getmobanChuzhiList">
            <el-button slot="append" icon="el-icon-search" @click="getmobanChuzhiList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="openAddDialog">添加储值卡模版</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="0" class="el_row_two">
        <el-col :span="24">
          <el-table :data="mobanChuzhiList" style="width: 100%" border stripe>
            <!-- <el-table-column type="index" label="序号" width="80"></el-table-column> -->
            <el-table-column prop="uid" label="序号" width="80"></el-table-column>
            <el-table-column prop="mb_name" label="模版名称"></el-table-column>
            <el-table-column prop="add_time" label="创建时间"></el-table-column>

            <el-table-column label="操作">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" :enterable="false">
                  <el-button type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.uid)" circle
                    size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-button v-show="(scope.row.mobanChuzhi_name !== 'admin')" type="danger" icon="el-icon-delete" circle
                    size="mini" @click="deleteForm(scope.row.uid)"></el-button>
                </el-tooltip>

              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNum" :page-sizes="[10, 50]" :page-size="queryInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
        <!--分页组件，其中handleSizeChange 条数下拉触发事件，  handleCurrentChange  选择分页出发事件 currentPage2 当前页绑定 page-sizes 下拉显示列表 page-size 每页多少条绑定 layout 显示分页的元素 total 合计条数绑定  -->
      </el-pagination>
      <!-- 添加储值卡模版部分 -->
      <el-dialog title="添加储值卡模版" :visible.sync="addDialogVisible" width="80%" @close="addDoalogClosed">
           <el-form ref="addFormRef" :model="addForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="模版名称" prop="mb_name">
            <el-input v-model="addForm.mb_name" show-word-limit></el-input>
          </el-form-item>
         </el-form>
        <div><el-card>
            <el-table ref="multipleTable" :data="addFormYouhui" tooltip-effect="dark" style="width: 100%"
              @selection-change="handleSelectionChange" :default-sort="{ prop: 'uid', order: 'descending' }">
              <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index }}</template>
              </el-table-column>
              <el-table-column prop="chongzhi_m" label="充值" show-overflow-tooltip width="200" >
              </el-table-column>
              <el-table-column prop="youhui_m" label="赠送" show-overflow-tooltip width="200" >
              </el-table-column>
              <el-table-column fixed="right" label="操作" min-width="200">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="add_Youhui_deleteRow(scope.$index, addFormYouhui)" size="small"
                    icon="el-icon-circle-close" style="font-size: 22px;" type="text">
                  </el-button>
                  <el-button @click.native.prevent="add_Youhui_editRow(scope.$index, addFormYouhui)" size="small"
                    icon="el-icon-edit-outline" style="font-size: 22px;" type="text">
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-form :model="add_Youhui_input_data" :rules="newInputRules" ref="newInputRef">
              <div class="Youhui_submit">
                 
                  <div><el-form-item label="充值" label-width="3" style="width: 200px" prop="gonglv">
                    <el-input v-model="add_Youhui_input_data.chongzhi_m" max="11" min="10" style="width: 100px"
                      @input="input_chongzhi_m_validate()"></el-input> 元
                  </el-form-item></div>
                <div><el-form-item label="赠送" label-width="3" style="width: 200px" prop="Youhui">
                    <el-input v-model="add_Youhui_input_data.youhui_m" max="11" min="10" style="width: 100px"
                      @input="input_youhui_m_validate()"></el-input> 元
                  </el-form-item></div>
                <div style="margin-top: 0px;text-align: left; margin-left: 10px;">
                  <el-button @click="add_Youhui_add()" style="font-size: 22px;" type="text"
                    icon="el-icon-circle-plus-outline"></el-button>
                 
                </div>

              </div>
            </el-form> </el-card>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addmobanChuzhi">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 修改储值卡模版信息 -->
      <el-dialog title="修改储值卡模版信息" :visible.sync="editDialogVisible" width="80%" @close="editDoalogClosed">
        <el-form ref="editFormRef" :model="editForm" :rules="addFormRules" label-width="100px">
          <el-form-item label="储值卡模版名称" prop="mb_name">
            <el-input v-model="editForm.mb_name" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <div><el-card>
            <el-table ref="multipleTable" :data="editFormYouhui" tooltip-effect="dark" style="width: 100%"
              @selection-change="handleSelectionChange" :default-sort="{ prop: 'xuhao', order: 'descending' }">
              <el-table-column width="80" label="序号"> <template slot-scope="scope">{{ scope.$index }}</template>
              </el-table-column>
              <el-table-column prop="chongzhi_m" label="充值" show-overflow-tooltip width="200" >
              </el-table-column>
              <el-table-column prop="youhui_m" label="赠送" show-overflow-tooltip width="200" >
              </el-table-column>

              <el-table-column fixed="right" label="操作" min-width="200">
                <template slot-scope="scope">
                  <el-button @click.native.prevent="update_Youhui_deleteRow(scope.$index, editFormYouhui)" size="small"
                    icon="el-icon-circle-close" style="font-size: 22px;" type="text">
                  </el-button>
                  <el-button @click.native.prevent="update_Youhui_editRow(scope.$index, editFormYouhui)" size="small"
                    icon="el-icon-edit-outline" style="font-size: 22px;" type="text">
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-form :model="update_Youhui_input_data" :rules="newInputRules" ref="update_Youhui_input_data">
              <div class="Youhui_submit">
                <div><el-form-item label="充值" label-width="3" style="width: 200px" prop="gonglv">
                    <el-input v-model="update_Youhui_input_data.chongzhi_m" max="11" min="10" style="width: 100px"
                      @input="update_input_chongzhi_m_validate()"></el-input> 元
                  </el-form-item></div>
                <div><el-form-item label="赠送" label-width="3" style="width: 200px" prop="Youhui">
                    <el-input v-model="update_Youhui_input_data.youhui_m" max="11" min="10" style="width: 100px"
                      @input="update_input_youhui_m_validate()"></el-input> 元
                  </el-form-item></div>
                <div style="margin-top: 0px;text-align: left;margin-left: 12px;">
                  <el-button @click="update_Youhui_add()" icon="el-icon-circle-plus-outline" style="font-size: 22px;"
                    type="text"></el-button>
                  <!-- <el-button @click="toggleSelection([tableData[1], tableData[2]])">添加</el-button> -->

                </div>

              </div>
            </el-form> </el-card>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updatemobanChuzhi">更 新</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from '../../tongyong/config/validator';
export default {
  data() {
    return {
      numberPattern: '^\\d+(\\.\\d{0,2})?$', // 正则表达式，限制小数点后最多两位
      // 删除按钮是否可见
      // 获取储值卡模版列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'mobanChuzhi_list',
        query: '',
        pageNum: 1,
        pageSize: 10,
        qiye_uid: window.sessionStorage.getItem('qiye_uid')
      },
      mobanChuzhiList: [],
      // 用于下拉框的数据读取
      //  recordCount: 0,
      total: 0,
      addDialogVisible: false,
      editDialogVisible: false,
      add_isDisable: false,
      //  添加表单数据项
      addForm: {
        C_type: 'yysMobanChuzhi_add',
        mb_name: ''
      },
      add_Youhui_input_data: {
        chongzhi_m: 0.0,
        youhui_m: 0.0
      },
      update_Youhui_input_data: {
        chongzhi_m: 0.0,
        youhui_m: 0.0
      },
      old_gonglv02: 0,
      // 用于修改数据绑定
      editForm: {},
      addFormYouhui: [],
      editFormYouhui: [],
      edit_update_flag: 0,
      edit_update_row: 0,
      // 表单规则项
      addFormRules: {
        mb_name: [
          { required: true, message: '请输入储值卡模版名称', trigger: 'blur' },
          { min: 1, max: 10, message: '必须1到10位字符 ', trigger: 'blur' }
        ] 
      },
      newInputRules: {
    
        chongzhi_m: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        youhui_m: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      },
      
      editFormRules: {},

      multipleSelection: []

    }
  },
  created() {
    this.getmobanChuzhiList();
  },
  methods: {
    openAddDialog() {
      // this.getJueseList()
      this.addDialogVisible = true
    },
    async getmobanChuzhiList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      });
      this.mobanChuzhiList = JSON.parse(res.data)[0].dataList;
      if (!this.mobanChuzhiList) return;
      this.mobanChuzhiList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1;
      });

      this.total = JSON.parse(res.data)[0].total;

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getmobanChuzhiList();
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getmobanChuzhiList();
    },
    addDoalogClosed() {
      this.$refs.addFormRef.resetFields()
      this.$refs.newInputRef.resetFields()
      this.addFormYouhui.splice(0, 10)
    },
    addmobanChuzhi() {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) {
          // console.log(123)
          return 1
        }
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        // console.log(123)
        const { data: res } = await this.$http.post('api', this.addForm);
        console.log(JSON.parse(res.data)[0].status);
        if (JSON.parse(res.data)[0].status === 202) {
          this.$message.error('储值卡模版名重复，添加失败');
          return;
        }
        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('添加失败');
          return;
        }
        var mobanChuzhiUidNow = JSON.parse(res.data)[0].mobanChuzhi_uid_now
        const obj = this.addFormYouhui
           obj.forEach((item, index) => {
          const data = {
            C_type: 'yysMobanChuzhi_add_youhui',
            chongzhi_m: item.chongzhi_m,
            youhui_m: item.youhui_m,
             mobanChuzhi_uid: mobanChuzhiUidNow,
            xuhao: index
          }
          const { data: res02 } = this.$http.post('api', data);
        })

        this.$message.success('添加成功');
        this.getmobanChuzhiList();
        this.addDialogVisible = false;
      });
    },
    updatemobanChuzhi() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        const { data: res } = await this.$http.post('api', {
          C_type: 'yysMobanChuzhi_update',
          moban_uid: this.editForm.moban_uid,
          mb_name: this.editForm.mb_name
           
        })
        const { data: res2 } = await this.$http.post('api', {
          C_type: 'yysMobanChuzhi_youhui_delete',
          moban_uid: this.editForm.moban_uid
        })

        if (JSON.parse(res.data)[0].status !== 200) {
          this.$message.error('更新失败');
          return;
        }
        // var mobanChuzhiUidNow = JSON.parse(res.data)[0].mobanChuzhi_uid_now
        const obj = this.editFormYouhui

        obj.forEach((item, index) => {
          const data = {
            C_type: 'yysMobanChuzhi_add_youhui',
            chongzhi_m: item.chongzhi_m,
            youhui_m: item.youhui_m,
            mobanChuzhi_uid: this.editForm.moban_uid,
            xuhao: index
          }
          const { data: res02 } = this.$http.post('api', data);
        })

        this.$message.success('更新成功');
        this.getmobanChuzhiList();
        this.editDialogVisible = false;
      });
    },
  
    showEditDialog(uid) {
      this.mobanChuzhiInfo(uid);
      this.getmobanChuzhiYouhuiList(uid);
      this.editDialogVisible = true;
    },
    editDoalogClosed() {
      this.$refs.editFormRef.resetFields();
      // this.$refs.editYouhuiFormRef.resetFields();
      this.editFormYouhui.splice(0, 10)
    },
    async mobanChuzhiInfo(uid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'mobanChuzhi_info', uid: uid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))
      // console.log(res.data);
      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }
      this.editForm = JSON.parse(res.data)[0].data[0];
    },
    async getmobanChuzhiYouhuiList(mobanChuzhiUid) {
      const { data: res } = await this.$http.get('get_api', {
        params: { C_table_name: 'mobanChuzhi_youhui_info', uid: mobanChuzhiUid, C_type: 'get_info' }
      });
      // console.log(JSON.parse(res.data))

      if (JSON.parse(res.data)[0].status !== 200) {
        return this.$message.error('读取失败');
      }
      console.log(JSON.parse(res.data)[0].data);
      // 无记录就是undefined
      if (JSON.parse(res.data)[0].data !== undefined) this.editFormYouhui = JSON.parse(res.data)[0].data;
    },

    // 删除一条记录
    async deleteForm(mobanChuzhiUid) {
      // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
      // 异步操作有2个，1个对话框等待，1个是网络请求
      const comfirmResult = await this.$confirm(
        '确定删除该条记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err);
      console.log(comfirmResult);
      if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
      const { data: res } = await this.$http.post('api', {
        C_type: 'record_delete',
        C_table_name: 'mobanChuzhi_del',
        C_data1: mobanChuzhiUid
      });
      if (JSON.parse(res.data)[0].status !== 200) {
        this.$message.error('删除失败');
        return;
      }
      this.$message.success('删除成功');
      this.getmobanChuzhiList();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    add_Youhui_add() {
      this.$refs.newInputRef.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)

        var dataAdd = {
          chongzhi_m: parseFloat(this.add_Youhui_input_data.chongzhi_m),
          youhui_m: parseFloat(this.add_Youhui_input_data.youhui_m)
        }
        
        if (this.edit_update_flag === 1) {
          this.addFormYouhui.splice(this.edit_update_row, 1, dataAdd)
          this.edit_update_flag = 0
        } else {
          this.addFormYouhui.push(dataAdd)
        }
        console.log(this.addFormYouhui)
             this.add_Youhui_input_data = {
              chongzhi_m: 0.0,
              youhui_m: 0.0
          }
      });
    },
    update_Youhui_add() {
      this.$refs.update_Youhui_input_data.validate(async valid => {
        if (!valid) return 1;
        this.add_isDisable = true
        setTimeout(() => {
          this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
        }, 2000)
        var dataAdd = {
          chongzhi_m: parseFloat(this.update_Youhui_input_data.chongzhi_m),
          youhui_m: parseFloat(this.update_Youhui_input_data.youhui_m) 
        }
        if (this.edit_update_flag === 1) {
          this.editFormYouhui.splice(this.edit_update_row, 1, dataAdd)
        
          this.edit_update_flag = 0
        } else {
          this.editFormYouhui.push(dataAdd)
        }
        console.log(this.editFormYouhui)
          this.update_Youhui_input_data = {
              chongzhi_m: 0.0,
              youhui_m: 0.0
          }
      });
    },
    add_Youhui_deleteRow(index, rows) {
      rows.splice(index, 1)
    },
    update_Youhui_deleteRow(index, rows) {
      rows.splice(index, 1)
    },

    update_Youhui_editRow(index, rows) {
      this.edit_update_flag = 1
      this.edit_update_row = index
      this.update_Youhui_input_data.chongzhi_m = rows[index].chongzhi_m
      this.update_Youhui_input_data.youhui_m = rows[index].youhui_m
    },
    add_Youhui_editRow (index, rows) {
      this.edit_update_flag = 1
      this.edit_update_row = index
      this.add_Youhui_input_data.chongzhi_m = rows[index].chongzhi_m
      this.add_Youhui_input_data.youhui_m = rows[index].youhui_m
    },
    handleChange() {},
    test() {
      console.log(this.addForm)
    },
    input_chongzhi_m_validate() {
      this.add_Youhui_input_data.chongzhi_m = this.add_Youhui_input_data.chongzhi_m.replace(/[^\d.]/g, '')
    },
    input_youhui_m_validate() {
      this.add_Youhui_input_data.youhui_m = this.add_Youhui_input_data.youhui_m.replace(/[^\d.]/g, '')
    },
  
  //  *************更新窗口***********
    update_input_chongzhi_m_validate() {
      this.update_Youhui_input_data.chongzhi_m = this.update_Youhui_input_data.chongzhi_m.replace(/[^\d.]/g, '')
    },
    update_input_youhui_m_validate() {
      this.update_Youhui_input_data.youhui_m = this.update_Youhui_input_data.youhui_m.replace(/[^\d.]/g, '')
    } 
    
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}

.el_row_two {
  margin-top: 30px;
}

.width_input {
  width: 300px;
}

.xiabanmian_add {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.Youhui_submit {
  margin-left: 10px;
  margin-top: 15px;
  width:900px;
  display: flex;
  flex-direction: row;
  justify-content: left;
}
</style>
